<template>
    <div class="verified-input">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <div :class="icon || (hideInfo && innerHideInfo) ? 'field has-addons' : ''">
            <div class="control" v-if="innerHideInfo">
                <a
                    class="button"
                    @click="innerInfoIsHidden = !innerInfoIsHidden"
                    :class="{ 'invalid-button-before': focusedOut && invalid }"
                >
                    <b-icon v-if="!innerInfoIsHidden" icon="eye-off-outline" type="is-danger" />
                    <b-icon v-if="innerInfoIsHidden" icon="eye-outline" type="is-success" />
                </a>
            </div>
            <div :class="icon || (hideInfo && innerHideInfo) ? 'control is-expanded' : ''">
                <input
                    v-if="!useMask"
                    ref="typed"
                    class="v-input"
                    :id="innerId"
                    :key="innerId"
                    :type="innerType"
                    :step="step"
                    :min="min"
                    :max="max"
                    :placeholder="
                        disableMLplaceholder
                            ? placeholder
                            : getT(placeholder, '')
                    "
                    :maxlength="maxlength"
                    :class="{
                        invalid: focusedOut && invalid && innerInvalidWhenDisabled,
                        smaller: smaller,
                        'text-uppercase': uppercase,
                        'input-icon': icon,
                        'input-hide': innerHideInfo,
                        'hidden-field': hideInfo && innerInfoIsHidden
                    }"
                    :disabled="disabled"
                    :readonly="readonly"
                    :tabindex="tabindex"
                    @focus="focusEvt()"
                    @keyup="onKeyUp($event)"
                    @input="updateValue()"
                    @blur="blurEvt()"
                    v-model="innerValue"
                />
                <input
                    v-else
                    ref="typed"
                    class="v-input"
                    :id="innerId"
                    :key="innerId + 'masked'"
                    :type="innerType"
                    :step="step"
                    :min="min"
                    :max="max"
                    :placeholder="
                        disableMLplaceholder
                            ? placeholder
                            : getT(placeholder)
                    "
                    :maxlength="maxlength"
                    :class="{
                        invalid: focusedOut && invalid,
                        smaller: smaller,
                        'text-uppercase': uppercase,
                        'input-icon': icon,
                        'input-hide': innerHideInfo,
                    }"
                    :disabled="disabled"
                    :readonly="readonly"
                    :tabindex="tabindex"
                    @focus="focusEvt()"
                    @keyup="onKeyUp($event)"
                    @input="updateValue()"
                    @blur="blurEvt()"
                    v-model="innerValue"
                    v-mask="[vMask[0], vMask[1] ? vMask[1] : vMask[0]]"
                />
            </div>
            <div class="control" v-if="icon && value != null && value != ''">
                <span
                    v-if="iconTooltip"
                    v-tippy 
                    :title="$t(iconTooltip)"
                >
                    <VerifieldInputIcon
                        :icon="icon"
                        :iconSvg="iconSvg"
                        :focusedOut="focusedOut"
                        :invalid="invalid"
                        @inputAction="inputAction"
                    />
                </span>
                <template v-else>
                    <VerifieldInputIcon
                        :icon="icon"
                        :iconSvg="iconSvg"
                        :focusedOut="focusedOut"
                        :invalid="invalid"
                        @inputAction="inputAction"
                    />
                </template>
            </div>
        </div>
        <span
            class="validation"
            v-text="getT(msg, '')"
            v-if="focusedOut && invalid && innerInvalidWhenDisabled"
        />
        <div class="clearfix" v-else-if="!noClearfix" />
    </div>
</template>

<script>
import VerifiedLable from '@/components/shared/VerifiedLable.vue';
import VerifieldInputIcon from '@/components/shared/VerifieldInputIcon.vue';

export default {
    components: {
        VerifiedLable,
        VerifieldInputIcon,
    },
    props: {
        value: {
            default: null,
        },
        id: {
            default: null,
        },
        placeholder: {
            default: 'placeholder-preencha',
            type: String,
        },
        maxlength: {
            default: 255,
            type: Number,
        },
        title: {
            default: '',
            type: String,
        },
        type: {
            default: 'text',
            type: String,
        },
        step: {
            default: '',
            type: [String, Number],
        },
        min: {
            default: '',
            type: [String, Number],
        },
        max: {
            default: '',
            type: [String, Number],
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        invalid: {
            default: false,
            type: [Boolean, Function],
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        invalidWhenDisabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            default: false,
            type: Boolean,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        onFocus: {
            default: () => {},
            type: Function,
        },
        onKeyUp: {
            default: () => {},
            type: Function,
        },
        smaller: {
            type: Boolean,
            default: false,
        },
        icon: {
            default: '',
            type: String,
        },
        iconTooltip: {
            default: '',
            type: String,
        },
        // true caso seja um ícone baixado
        iconSvg: {
            type: Boolean,
            default: false,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        validchars: {
            type: String,
            default: '',
        },
        uppercase: {
            type: Boolean,
            default: true,
        },
        noClearfix: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            type: String,
            default: null,
        },
        /* Ativa a ocultação da informação - Ativa o olho de visualizar/ocultar
        Adicionar no componente pai
        Adicionar no <v-input 
                :hideInfo="true"
            :infoIsHidden="hide.infoIsHidd
        */
        hideInfo: {
            type: Boolean,
            default: false,
        },
        infoIsHidden: {
            type: Boolean,
            default: true,
        },
        // Ativar o uso da mascara
        useMask: {
            type: Boolean,
            default: false,
        },
        // Passa a mascara
        vMask: {
            type: Array,
            default: () => [],
            //Ex: ['(##) ####-####', '(##) #####-####']
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        porcentagem: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerId: null,
            innerValue: this.value,
            focusedOut: false,
            innerType: this.type,
            innerHideInfo: this.hideInfo,
            innerInfoIsHidden: this.infoIsHidden,
            innerInvalidWhenDisabled: false,
        };
    },
    mounted() {
        this.focusedOut = !this.onBlur;
    },
    watch: {
        value(val) {
            // Pega os dados do value 'pai' somente ao haver alteração
            if (this.valuesAreEqual()) this.innerValue = val;
        },
        innerValue(val) {
            // Update do valor somente ao haver alteração
            if (this.valuesAreEqual()) this.updateValue();
        },
        type(val) {
            this.innerType = val;
        },
        hideInfo(val) {
            this.innerHideInfo = val;
        },
        infoIsHidden(val) {
            this.innerInfoIsHidden = val;
        },
        innerInfoIsHidden(val) {
            if (this.hideInfo && this.type === 'password') {
                this.innerType = val ? 'password' : 'text';
            }
        },
    },
    created() {
        this.innerId =
            this.id == null
                ? new Date().getTime() + '' + Math.floor(Math.random() * 10000)
                : this.id;

        if (this.hideInfo && this.type === 'password') {
            this.innerType = this.innerInfoIsHidden ? 'password' : 'text';
        }

        this.innerInvalidWhenDisabled =
            !this.disabled || (this.invalidWhenDisabled && this.disabled);
    },
    computed: {
        charsregex() {
            if (!this.isNull(this.validchars)) {
                let rgx = '^[#]*$';
                let unc = '';
                let vc_array = this.validchars.split('');

                vc_array.forEach((c) => {
                    unc = unc.concat(`\\u${c.charCodeAt(0).toString(16).padStart(4, '0')}`);
                });

                return new RegExp(rgx.replace('#', unc));
            } else {
                return null;
            }
        },
    },
    methods: {
        valuesAreEqual() {
            // Modificado para pegar os dados do value 'pai' somente ao haver alteração
            let tempValue =
                this.onlyNumbers(this.value) || this.isNull(this.value)
                    ? this.value
                    : this.value.toString().toUpperCase();
            let tempInnerValue =
                this.onlyNumbers(this.innerValue) || this.isNull(this.innerValue)
                    ? this.innerValue
                    : this.innerValue.toString().toUpperCase();
            // caso os valores sejam diferentes é chamado a atualização
            return tempInnerValue != tempValue;
        },
        updateValue() {
            let input = this.innerValue;

            /* Com input type number o maxlength não é validado
         no HTML, então a validação é feita aqui. */
            if (this.type == 'number') {
                if (input.length <= this.maxlength) {
                    this.emitValue(input);
                } else {
                    this.innerValue = this.value;
                }

                /* Verificar o validchars se não for tipo number */
            } else if (!this.isNull(this.validchars)) {
                if (
                    this.charsregex &&
                    this.charsregex.test(input ? input.toString().toLowerCase() : '')
                ) {
                    this.emitValue(input);
                } else {
                    this.innerValue = this.value;
                }

                /* Se não tiver, só faz o emit normal. */
            } else {
                this.emitValue(input);
            }
        },
        emitValue(value) {
            if (typeof value == 'string') {
                this.$emit('input', this.uppercase ? value.toString().toUpperCase() : value);
            } else {
                this.$emit('input', value);
            }
        },
        inputAction() {
            this.$emit('input-action');
        },
        focusEvt() {
            this.focusedOut = false;

            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            this.focusedOut = true;

            if (this.onBlur) {
                this.onBlurFunction();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
    },
};
</script>

<style lang="scss" scoped>
input::placeholder { font-family: "Montserrat", sans-serif; }
input:-ms-input-placeholder { font-family: "Montserrat", sans-serif; }
input::-ms-input-placeholder { font-family: "Montserrat", sans-serif; }


.hidden-field {
    font-family: text-security-disc;
    -webkit-text-security: disc;
    color: $text-color;
}

span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}
.invalid {
    border: 1px solid $red-alert !important;
}

input {
    margin-bottom: 0 !important;
    color: #666666;
    height: 36px;
}
.input-hide {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.input-icon {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.login-input {
    input {
        text-transform: none;
    }
}

.v-input.smaller {
    height: 24px;
    font-size: 12px;
}

.field.has-addons {
    margin-bottom: 0;
    .button {
        height: 36px;
        color: #666666;
        border-color: $table-border;

        &.invalid-button-before {
            border-bottom-color: red;
            border-left-color: red;
            border-top-color: red;
        }
        &.invalid-button-after {
            border-bottom-color: red;
            border-right-color: red;
            border-top-color: red;
        }
    }
}
.clearfix {
    height: 12px;
}
</style>
